import { defineMessages } from 'react-intl'

export default defineMessages({
  faq: {
    id: 'components.Footer.faq',
    defaultMessage: 'FAQ',
  },
  faqHref: {
    id: 'components.Footer.faq.href',
    defaultMessage: 'https://www.voicearchive.com/faq',
  },
  applyAsVoiceTalent: {
    id: 'components.Footer.applyAsVoiceTalent',
    defaultMessage: 'Apply as voice talent',
  },
  applyAsVoiceTalentHref: {
    id: 'components.Footer.applyAsVoiceTalent.href',
    defaultMessage: 'https://www.voicearchive.com/apply-voice-talent/',
  },
  termsAndConditions: {
    id: 'components.Footer.termsAndConditions',
    defaultMessage: 'Terms and conditions',
  },
  termsAndConditionsHref: {
    id: 'components.Footer.termsAndConditions.href',
    defaultMessage: 'https://www.voicearchive.com/terms-conditions/',
  },
  privacyPolicy: {
    id: 'components.Footer.privacyPolicy',
    defaultMessage: 'Privacy policy',
  },
  privacyPolicyHref: {
    id: 'components.Footer.privacyPolicy.href',
    defaultMessage: 'https://www.voicearchive.com/privacy-policy/',
  },
  contactUs: {
    id: 'components.Footer.contactUs',
    defaultMessage: 'Contact us',
  },
  contactUsHref: {
    id: 'components.Footer.contactUs.href',
    defaultMessage: 'https://www.voicearchive.com/contact/',
  },
  explore: {
    id: 'components.Footer.explore',
    defaultMessage: 'Find voice',
  },
})
